module.exports = __webpack_public_path__ + "img/typhoon_50.a3c4f68f.png";